import { useDispatch, useSelector } from 'react-redux'
import { selectActiveBot } from 'tabs/home/reducers/selectors'
import { selectQuestionTypeFilter } from 'tabs/topQuestions/lib/top_questions_search/topQuestionsSearchSelectors'
import { selectClusterColorsMap, selectTopQuestionsRequest } from 'tabs/topQuestions/lib/top_questions/topQuestionsSelectors'
import React, { useEffect } from 'react'
import { RequestStatus } from 'tabs/topQuestions/types/GenericTypes'
import { fetchTopQuestions } from 'tabs/topQuestions/lib/top_questions/topQuestionsApi'
import { TopQuestionsList } from 'tabs/topQuestions/components/top_questions_list/TopQuestionsList'
import { FetchClusterQuestions } from 'tabs/topQuestions/types/ApiResponses'
import { CircularProgress } from '@mui/material'
import { ClusteringCheckStatus } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusSlice'

type QuestionClusterListInitializerProps = {
  trainingStatus: ClusteringCheckStatus
  clusteringExecutionId: string
  sendFetchClusterQuestionsMessage: (request: FetchClusterQuestions) => void,
}
export const TopQuestionsListInitializer: React.FC<QuestionClusterListInitializerProps> = ({
                                                                                             trainingStatus,
                                                                                             clusteringExecutionId,
                                                                                             sendFetchClusterQuestionsMessage,
                                                                                           }) => {
  const activeBot = useSelector(selectActiveBot)
  const dispatch = useDispatch()
  const activeBotId = activeBot.id
  const selectedQuestionType = useSelector(selectQuestionTypeFilter)
  const topQuestionsRequestStatus = useSelector(selectTopQuestionsRequest)
  const topQuestionsColors = useSelector(selectClusterColorsMap)

  const isNotTraining = trainingStatus.status != 'PENDING'

  // called when the filter has changed
  // called when there was no data and user manually triggered clustering
  useEffect(() => {
    if (isNotTraining && clusteringExecutionId != null && activeBotId != null && selectedQuestionType != null) {
      dispatch(fetchTopQuestions(clusteringExecutionId, activeBotId, selectedQuestionType))
    }
  }, [trainingStatus.status, clusteringExecutionId, activeBotId, selectedQuestionType])

  if (isNotTraining) {
    if (topQuestionsColors == undefined) {
      return <></>
    } else {
      switch (topQuestionsRequestStatus) {
        case RequestStatus.NONE:
          return <></>
        case RequestStatus.PENDING:
          return <CircularProgress />
        case RequestStatus.RESOLVED:
          return <TopQuestionsList clusteringExecutionId={clusteringExecutionId}
                                   topQuestionsColors={topQuestionsColors}
                                   sendFetchClusterQuestionsMessage={sendFetchClusterQuestionsMessage} />
        case RequestStatus.REJECTED:
          return <h4>Failed to retrieve top questions</h4>
      }
    }
  } else {
    return <CircularProgress />
  }
}
